// 头部
import request from "@/utils/request";

// 通知列表
export function getSystemNoticeList(data) {
  return request({
    url: "/merchant/systemNotice/getSystemNoticeList",
    method: "get",
    params: data
  });
}

// 是否有红点
export function isCkeckNoticet(data) {
  return request({
    url: "/merchant/systemNotice/isCkeckNotice",
    method: "get",
    params: data
  });
}

export function readNotice(data) {
  return request({
    url: "/merchant/systemNotice/readNotice",
    method: "post",
    data: data
  });
}
